import { render, staticRenderFns } from "./ItsBaseTeamDetail.vue?vue&type=template&id=2b9b1149&scoped=true&"
import script from "./ItsBaseTeamDetail.vue?vue&type=script&lang=js&"
export * from "./ItsBaseTeamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsBaseTeamDetail.vue?vue&type=style&index=0&id=2b9b1149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b1149",
  null
  
)

export default component.exports